import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import DataComponent from '../../../DataComponent/DataComponent';
import CustomModal from '../../../Modal';
import CustomTooltip from '../../../Tooltip';
import FormGroup from '../../../FormGroup';
import Icon from '../../../Icon';
import {isMobile} from "utils/DeviceDetect";
import { I18nContext } from 'utils/I18n/context';

const HistoryList = ({
    total,
    page,
    loading,
    list,
    headerNames,
    statuses,
    conversionStatuses,
    postbacks,
    actionTypes,
    actionNames,
    getListPostbacks,
    getListHistoryPostbacks
}) => {
    const { t } = useContext(I18nContext);
    const [state, setState] = useState({
        list: [],
        totalPages: total,
        page: page,
        loading: loading,
        modalIsVisible: false,
        sendAttempts: []
    });

    const staticNamesHistory = t?.postbackPage?.history || {};
    const staticNameTable = t?.dataTable || {};

    const onDataTableAction = useCallback((state, actionType) => {
        getListHistoryPostbacks(state);
    }, [getListHistoryPostbacks]);

    const toggleModal = useCallback(() => {
        setState(prev => ({
            ...prev,
            modalIsVisible: !prev.modalIsVisible
        }));
    }, []);

    const onVisibleSendAttempts = useCallback((event) => {
        const index = event.target.closest('.history-postback__more').getAttribute('data-index');

        setState(prev => ({
            ...prev,
            sendAttempts: prev.list[index].sendAttempts
        }));

        toggleModal();
    }, [toggleModal]);

    const getList = useCallback(() => {
        let list = [];

        state.list.forEach((item, index) => {
            if (isMobile) {
                list.push({
                    ...item,
                    sendAttempts: (
                        <div>
                            <span>{item.sendAttempts.length}</span>
                        </div>
                    ),
                    actions: (
                        <div className="row-controls">
                            {item.sendAttempts.length > 0
                                ? (
                                    <CustomTooltip id={`more-${index}`} tooltip={staticNamesHistory.more}>
                                        <a className="history-postback__more view-button" href="#!"
                                           onClick={onVisibleSendAttempts}
                                           data-index={index}>
                                            <img src={images.eye} alt=""/><span
                                            className={'link-title'}>{staticNamesHistory.more}</span>
                                        </a>
                                    </CustomTooltip>
                                )
                                : null
                            }
                        </div>
                    )
                });
            } else {
                list.push({
                    ...item,
                    sendAttempts: (
                        <div>
                            <span>{item.sendAttempts.length}</span>
                            {!isMobile && item.sendAttempts.length > 0
                                ? (
                                    <CustomTooltip id={`more-${index}`} tooltip={staticNamesHistory.more}>
                                        <a className="history-postback__more view-button" href="#!" onClick={onVisibleSendAttempts}
                                           data-index={index}>
                                            <img src={images.eye} alt=""/>
                                        </a>
                                    </CustomTooltip>
                                )
                                : null
                            }
                        </div>
                    )
                });
            }
        });

        return list;
    }, [state.list, staticNamesHistory, onVisibleSendAttempts]);

    useEffect(() => {
        getListPostbacks();
    }, [getListPostbacks]);

    useEffect(() => {
        const list = [];
        for( let coversion of list) {
            let conversionFiltred = {};
            let pushConverios = false;
            for( let dataField in coversion) {
                if(headerNames.find( header => header.keyTitle === dataField).visible) {
                    conversionFiltred[dataField] = coversion[dataField];
                    if(!pushConverios) {
                        pushConverios = true;
                    }
                }
            }
            if(pushConverios) {
                list.push(conversionFiltred);
            }
        }
        setState(prev => ({
            ...prev,
            list,
            totalPages: total,
            page: page,
            loading: loading
        }));
    }, [list, total, page, loading, headerNames]);

    return (
        <div className="ibox-content">
            <div className={`history-postback__table ${isMobile ? 'mobile-view' : ''}`}>
                <DataComponent
                    onAction={onDataTableAction}
                    totalPages={state.totalPages}
                    headerNames={headerNames}
                    headerNamesArray={false}
                    autoTile={true}
                    data={getList()}
                    loading={state.loading}
                    isQuery={true}
                    settings={true}
                    settingKey={'postbackHistory'}
                    tableBodyTitle={staticNamesHistory.title}
                    className="simple-table"
                    gray={true}
                    fields={[
                        {
                            name: 'datepicker',
                            key: 'create',
                            label: staticNameTable.headers?.createdAt,
                            dropdownLabel: staticNameTable.filter,
                            disabled: true
                        },
                        {
                            name: 'datepicker',
                            key: 'updated',
                            label: staticNameTable.headers?.updatedAt,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'datepicker',
                            key: 'conversionCreated',
                            label: staticNameTable.headers?.createdAtConversion,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'datepicker',
                            key: 'conversionUpdated',
                            label: staticNameTable.headers?.updatedAtConversion,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'datepicker',
                            key: 'trackСreated',
                            label: staticNameTable.headers?.createdAtTrack,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'dynamic',
                            key: 'offer',
                            segment: 'Offer',
                            label: staticNameTable.headers?.offerTitle,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'custom',
                            key: 'conversions',
                            label: staticNameTable.headers?.conversion,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'goalTree',
                            key: 'goals',
                            nesting: 'goals',
                            label: staticNameTable.headers?.goalTitle,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'goalTree',
                            key: 'goalActions',
                            label: staticNameTable.headers?.goalActions,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'multiselect',
                            key: 'statuses',
                            data: statuses,
                            placeholder: staticNameTable.tips?.byStatus,
                            label: staticNameTable.headers?.status,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'multiselect',
                            key: 'conversionStatuses',
                            data: conversionStatuses,
                            label: staticNameTable.headers?.conversionStatus,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'multiselect',
                            key: 'currentConversionStatuses',
                            data: conversionStatuses,
                            label: staticNameTable.headers?.currentConversionStatuses,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'multiselect',
                            key: 'postbackIds',
                            data: postbacks,
                            label: staticNameTable.headers?.conversionPostback,
                            placeholder: staticNamesHistory.placeholders?.postback,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'multiselect',
                            key: 'actionTypes',
                            data: actionTypes,
                            placeholder: staticNameTable.headers?.byActionType,
                            label: staticNameTable.headers?.typeAction,
                            dropdownLabel: staticNameTable.filter
                        },
                        {
                            name: 'multiselect',
                            key: 'actionNames',
                            data: actionNames,
                            placeholder: staticNameTable.headers?.byActionName,
                            label: staticNameTable.headers?.nameAction,
                            dropdownLabel: staticNameTable.filter
                        },
                        {name: 'custom', key: 'advCids', label: staticNameTable.headers?.advCid, dropdownLabel: staticNameTable.filter},
                        {name: 'custom', key: 'utmMedium', label: 'UtmMedium', dropdownLabel: staticNameTable.filter},
                        {name: 'custom', key: 'utmSource', label: 'UtmSource', dropdownLabel: staticNameTable.filter},
                        {name: 'custom', key: 'utmCampaign', label: 'UtmCampaign', dropdownLabel: staticNameTable.filter},
                        {name: 'custom', key: 'utmTerm', label: 'UtmTerm', dropdownLabel: staticNameTable.filter},
                        {name: 'custom', key: 'utmContent', label: 'UtmContent', dropdownLabel: staticNameTable.filter},
                        {name: 'custom', key: 'param1', label: 'Param1', dropdownLabel: staticNameTable.filter},
                        {name: 'custom', key: 'param2', label: 'Param2', dropdownLabel: staticNameTable.filter},
                        {name: 'custom', key: 'param3', label: 'Param3', dropdownLabel: staticNameTable.filter},
                        {name: 'custom', key: 'param4', label: 'Param4', dropdownLabel: staticNameTable.filter},
                    ]}
                />
                <CustomModal
                    visible={state.modalIsVisible}
                    onClose={toggleModal}
                    title={staticNameTable.headers?.sendAttempts}
                    areNoControls={true}
                >
                    <div className="form-horizontal">
                        {state.sendAttempts.map((item, index) => (
                            <div key={index}>
                                {index !== 0
                                    ? <div className="hr-line-dashed" />
                                    : null
                                }
                                <FormGroup
                                    label={item.date}
                                    labelClass="col-lg-2"
                                    fieldClass="col-lg-10"
                                >
                                    <textarea className="form-control form-textarea m-b history-postback__textarea" value={item.request} readOnly />
                                    <textarea className="form-control form-textarea history-postback__textarea" value={item.response} readOnly />
                                </FormGroup>
                            </div>
                        ))}
                    </div>
                </CustomModal>
            </div>
        </div>
    );
};

HistoryList.propTypes = {
    total: PropTypes.number,
    page: PropTypes.number,
    loading: PropTypes.bool,
    list: PropTypes.array,
    headerNames: PropTypes.array,
    statuses: PropTypes.array,
    conversionStatuses: PropTypes.array,
    postbacks: PropTypes.array,
    actionTypes: PropTypes.array,
    actionNames: PropTypes.array,
    getListPostbacks: PropTypes.func,
    getListHistoryPostbacks: PropTypes.func
};

HistoryList.defaultProps = {
    total: 0,
    page: 1,
    loading: false,
    list: [],
    headerNames: [],
    statuses: [],
    conversionStatuses: [],
    postbacks: [],
    actionTypes: [],
    actionNames: [],
    getListPostbacks: () => {},
    getListHistoryPostbacks: () => {}
};

export default HistoryList;
